import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import leftimg from "../../assets/mathLeftImg.png";
import rightimg from "../../assets/mathRightImg.png";
import abacusJ from "../../assets/BrainTrainAbacusJ.png";
import abacus from "../../assets/BrainTrainAbacus.png";
import CourseExplorer from "../../MyComponents/CourseExplorer";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";

const courses = [
  {
    title: "Brain Train Abacus (Junior)",
    image: abacusJ,
    path: "/brain-train-abacus-junior",
  },
  { title: "Brain Train Abacus", image: abacus, path: "/brain-train-abacus" },
];

const MathPortal = () => {
  const mathpage = heroContent.mathpage;
  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={mathpage.titlePart1}
        titlePart2={mathpage.titlePart2}
        description={mathpage.description}
        buttonText={mathpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseExplorer
        title="Explore Our Fun & Skill-Boosting Math Courses"
        highlightText="Math Courses"
        courses={courses}
      />

      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default MathPortal;
